<template>
	<div class="addressBar">
		<p class="PL fl"><a href="">{{addressBarData.PColumn ? addressBarData.PColumn.Name : addressBarData.lanmu.Name}}
      <em>{{addressBarData.PColumn ? addressBarData.PColumn.Aliase : addressBarData.lanmu.Aliase}}</em></a>
    </p>
		<p class="PR fr">
			<!-- 当前位置：<router-link to="./" >首页 >>&nbsp;</router-link> -->
			<!-- <router-link v-if="addressBarData.PColumn" :href="addressBarData.PColumn.Url" :to="addressBarData.PColumn.Url"  @click.native="OpenLink(item.Url)">{{addressBarData.PColumn.Name}} >>&nbsp;</router-link> -->
			<!-- <router-link :to="addressBarData.lanmu.Url"  :href="addressBarData.lanmu.Url"  @click.native="OpenLink(addressBarData.lanmu.Url)" >{{addressBarData.lanmu.Name}}</router-link> -->
      <router-link v-for="(item,index) in addressBarData.List" :to="item.Url" :href="item.Url" :key='item.ID'>{{item.Name}}</router-link>
		</p>
	</div>
</template>

<script>
	export default{
		name:'addressBar',
		props:{
			addressBarData:{
				type: Object,
				  default: () => {
					  return {
              PColumn:{},
              lanmu:{},
              List:[]
					  }
				  }
			},
			moreLink: {
			   type: String,
			   default: ''
			 }
		}
	}
</script>

<style lang="less" scoped="scoped">
	.addressBar{
		height: 56px;
		border-bottom: solid 1px #dadada;
		.PL{
			font-size: 18px;
			color: #32454F;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 1px;
      padding-left: 12px;
      position: relative;
      &::before{
        content: '';
        width: 3px;
        height: 34px;
        background: #32454F;
        position: absolute;
        left: 0;
        top: 16px;
      }
      a{
        display: block;
        line-height: 46px;
        em{
          display: block;
          font-size: 12px;
          font-family: Helvetica;
          line-height: 0;
          color: #32454F;
        }
      }

		}
		.PR{
			font-size: 16px;
			color: #333333;
			font-weight: normal;
			font-stretch: normal;
			line-height: 72px;
			letter-spacing: 1px;
      padding-right: 18px;
      a{
        margin-left: 50px;
      }
      a.router-link-exact-active{
        color: #0069B7;
        position: relative;
        &::after{
          content: '';
          width: 51px;
          height: 1px;
          background: #0069B7;
          position: absolute;
          left: 10px;
          bottom: -11px;
        }
      }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/addressBar.vue